import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtGuestChatSection({}) {
  const isMobile = useMobile();
  const renderBox = (icon, text, containerStyle) => {
    return (
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            alignItems: "center",
            padding: 30,
          },
          containerStyle,
        ]}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtMaterialIcon name={icon} size={34} color="#006AFF" />
        </View>
        <NtText
          style={{
            color: "white",
            fontSize: 11,
            fontWeight: "600",
            marginTop: 15,
            textAlign: "center",
          }}
        >
          {text}
        </NtText>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          width: "100%",
        }}
      >
        <NtSectionTitle style={{ textAlign: "left" }}>
          GUEST-CHAT
        </NtSectionTitle>

        <NtSectionDescription style={{ marginTop: 20 }}>
          Onboard/Ship to Ship/Ship to Shore
        </NtSectionDescription>
      </View>

      <View
        style={{
          width: "100%",
          flexDirection: isMobile ? "column" : "row",
          marginTop: 30,
        }}
      >
        {renderBox("cellphone-sound", "Push-to-Talk Walkie Talkie", {
          marginRight: isMobile ? 0 : 10,
          flex: 1,
        })}
        {renderBox("message", "SMS/MMS", {
          marginRight: isMobile ? 0 : 10,
          marginTop: isMobile ? 10 : 0,
          flex: 1,
        })}
        {renderBox("translate", "Language Translator", {
          flex: 1,
          marginTop: isMobile ? 10 : 0,
        })}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtGuestChatSection;
